import { createRouter, createWebHistory } from "vue-router";
import Musoon from "../views/Musoon.vue";

const routes = [
  //根目錄
  {
    path: "/",
    name: "Musoon",
    component: Musoon
  },
  //開發用
  {
    path: "/devx",
    component: () => import("../views/Devx.vue")
  },
  //初診表查詢(供醫師台點擊)
  {
    path: "/:jwt/:platform/FirstVisitForm/:patientNo",
    component: () => import("../views/LandingPage.vue")
  },
  //QRCode報到機 qrcode:時間戳記
  {
    path: "/:jwt/:platform/CheckInQRCode/:qrcode",
    component: () => import("../views/LandingPage.vue")
  },
  //公開對外的網址 jwt:使用者驗證碼, platform:連線的作業平台, page:功能頁面
  {
    path: "/:jwt/:platform/:page",
    component: () => import("../views/LandingPage.vue")
  },
  {
    path: "/:jwt/:platform/:page/:dept?/:doctor?", //?=可有可無
    component: () => import("../views/LandingPage.vue")
  },
  //公開網址轉址至內部
  {
    path: "/HomePage",
    component: () => import("../views/HomePage.vue")
  },
  {
    path: "/SignUp", //註冊帳號
    component: () => import("../views/SignUp.vue")
  },
  {
    path: "/LogIn", //登入
    component: () => import("../views/LogIn.vue")
  },
  {
    path: "/MemberShip", //我的
    component: () => import("../views/MemberShip.vue")
  },
  {
    path: "/Appointment", //預約
    component: () => import("../views/Appointment.vue")
  },
  {
    path: "/AppointmentQuery", //預約查詢&取消
    component: () => import("../views/AppointmentQuery.vue")
  },
  /*{
    path: "/AppointmentWebQuery", //預約查詢&取消(網頁版)
    component: () => import("../views/AppointmentWebQuery.vue")
  },*/
  {
    path: "/CheckIn", //就診報到
    component: () => import("../views/CheckIn.vue")
  },
  {
    path: "/CheckInQRCode", //掃描QRCode報到
    component: () => import("../views/CheckInQRCode.vue")
  },
  {
    path: "/WaitInfo", //候診資訊
    component: () => import("../views/WaitInfo.vue")
  },
  {
    path: "/Notification", //推播訊息
    component: () => import("../views/Notification.vue")
  },
  {
    path: "/FeedBack", //意見反映
    component: () => import("../views/FeedBack.vue")
  },
  {
    path: "/MedicalInfo", //檢驗報告
    component: () => import("../views/MedicalInfo.vue")
  },
  {
    path: "/SurveyVisit", //滿意度調查
    component: () => import("../components/Survey/SurveyVisit.vue")
  },
  {
    path: "/SurveyRoom", //滿意度調查
    component: () => import("../components/Survey/SurveyRoom.vue")
  },
  {
    path: "/SurveyPostpartum", //滿意度調查
    component: () => import("../components/Survey/SurveyPostpartum.vue")
  },
  {
    path: "/FirstVisitForm", //初診問診單
    component: () => import("../views/FirstVisitForm.vue")
  },
  {
    path: "/VIPReservation", //VIP預約
    component: () => import("../views/VIPReservation.vue")
  },
  {
    path: "/Operation/:detail?", // 手術清單
    component: () => import("../views/Operation/Index.vue")
  },
  {
    path: "/Testing", //測試頁面
    component: () => import("../views/Testing.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), //BASE_URL 依據 vue.config.js 的 publicPath
  linkExactActiveClass: "current", //router href作用中欲套用的class名稱
  routes
});

export default router;
